export const STATUS_SORT_ORDER: {
	[key in string]: number;
} = {
	new: 1, // Represents "To Do"
	indeterminate: 2, // Represents "In Progress"
	done: 3, // Represents "Done"
};
